export default {
  getActiveStepForm: state => state.activeStepForm
}
